import React from 'react';

export default function workWithUs() {
    return (
        <div className="about-frame">

                <div id="about">
                    <p>THIS PAGE IS UNDER DEVELOPMENT.</p>
                </div>
            </div>
            );
            }